/**
 * Converts a number to its ordinal representation (e.g., 1 -> "1st").
 */
function numberToOrdinal(num: number): string {
	if (typeof num !== "number") return "";
	const suffixes = ["th", "st", "nd", "rd"];
	const remainder = num % 100;

	if (remainder >= 11 && remainder <= 13) {
		return `${num}th`;
	}

	const lastDigit = num % 10;
	const suffix = suffixes[lastDigit] ?? "th";

	return `${num}${suffix}`;
}

export default numberToOrdinal;
